var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"names"},[_vm._v("\n    "+_vm._s(_vm.fullNames)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"email"},[_vm._v("\n    "+_vm._s(_vm.email)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }